import Expander from "@irati/ui/src/Expander"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Hr} from "@irati/ui/src/Layout"
import Loading from "@irati/ui/src/Loading"
import {Tooltip} from "@irati/ui/src/Tooltip"
import {Body, H5} from "@irati/ui/src/Typography"
import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"
import React, {FC} from "react"
import ServiceFeesCards from "../TopUpRewardPoints/ServiceFeesCards"
import {SaveMore} from "../TopUpRewardPoints/styled"
import {State} from "./modalReducer"
import Price from "./Price"
import {CardGrid, GridSection} from "./styled"

interface Props extends InjectIntl {
  state: State
  currencyCode: string
  serviceFeesRequest: Promise<void>
}

const ServiceFeeInfo: FC<Props> = ({state, currencyCode, serviceFeesRequest, formatMessage}) => {
  const {serviceFee, status, tiers, currentTier} = state
  return (
    <>
      <Hr margin={0} />

      <Flex direction="column" gap>
        <Flex>
          <Body>
            <FormattedMessage id="wallet.reward.admin.card.topup.serviceFee" />
          </Body>
          <Tooltip
            tooltipChildren={
              <Body small>
                <FormattedMessage id="wallet.reward.admin.card.topup.tooltipBody" />
              </Body>
            }>
            <Icon icon={IconTypes.circleInformation} small marginLeft={1} />
          </Tooltip>
        </Flex>

        <CardGrid>
          <GridSection area="leftHeader">
            <H5>
              <FormattedMessage id="wallet.reward.admin.subscriptionBanner.modalSubscribe.fee.manual" />
            </H5>
          </GridSection>
          <GridSection area="leftPrice">
            <Price value={serviceFee?.manual} currencyCode={currencyCode} state={status} />
          </GridSection>
          <GridSection area="rightHeader">
            <H5>
              <FormattedMessage id="wallet.reward.admin.subscriptionBanner.modalSubscribe.fee.subscription" />
            </H5>
          </GridSection>
          <GridSection area="rightPrice">
            <Price value={serviceFee?.subscription} currencyCode={currencyCode} state={status} highlight />
          </GridSection>
        </CardGrid>
      </Flex>

      <Expander
        HeaderLabel={SaveMore}
        showText={formatMessage({id: "wallet.reward.admin.card.topup.serviceFeeExpanderText"})}
        iconSize={12}>
        <Loading load={serviceFeesRequest}>
          <ServiceFeesCards
            purchaseCurrency={currencyCode}
            serviceFeesTiers={tiers!}
            maxColumns={2}
            currentTier={status === "valid" ? currentTier : undefined}
          />
        </Loading>
      </Expander>
    </>
  )
}

export default injectIntl(ServiceFeeInfo)
